import Blockquote from '@tiptap/extension-blockquote'

export default Blockquote.extend({
  addAttributes() {
    return {
      class: {
        default: null,
        renderHTML: (attributes) => {
          return {
            class: `${attributes.class}`,
          }
        },
      },
    }
  },
})
